import { GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import { csvOptionsValues, printOptionsValues } from './dataGridUtils';

const CustomToolBarUtils: React.FC = () => {
  return (
    <>
      <GridToolbarContainer>
        <GridToolbarExport csvOptions={csvOptionsValues} printOptions={printOptionsValues} />
      </GridToolbarContainer>
    </>
  );
};
export default CustomToolBarUtils;